import { singularityFieldConfig } from "./singularityFieldConfig";

export type BlackHoleConfig = {
  blackHoleMass: number;
  diskInnerRadius: number;
  diskOuterRadius: number;
  diskTemperature: number;
  temperatureFalloff: number;
  diskBrightness: number;
  diskRotationSpeed: number;
  turbulenceScale: number;
  turbulenceStretch: number;
  turbulenceSharpness: number;
  turbulenceCycleTime: number;
  turbulenceLacunarity: number;
  turbulencePersistence: number;
  diskEdgeSoftnessInner: number;
  diskEdgeSoftnessOuter: number;
  gravitationalLensing: number;
  dopplerStrength: number;
  stepSize: number;
  renderShellRadius: number;
  raymarchEntryRadius: number;
  starsEnabled: boolean;
  starBackgroundColor: string;
  starDensity: number;
  starSize: number;
  starBrightness: number;
  nebulaEnabled: boolean;
  nebula1Scale: number;
  nebula1Density: number;
  nebula1Brightness: number;
  nebula1Color: string;
  nebula2Scale: number;
  nebula2Density: number;
  nebula2Brightness: number;
  nebula2Color: string;
  bloomStrength: number;
  bloomRadius: number;
  bloomThreshold: number;
  connectorWidth: number;
  connectorOpacity: number;
  connectorBrightness: number;
  connectorColor: string;
};

// Canonical values from the reference WebGPU black-hole project.
// Focus mode converges to this exact profile. Cosmos mode only changes camera distance,
// not the physical/material model.
export const blackHoleConfig: BlackHoleConfig = {
  blackHoleMass: singularityFieldConfig.blackHoleMass,
  diskInnerRadius: 4.1,
  diskOuterRadius: 14.5,
  diskTemperature: 49.78,
  temperatureFalloff: 5.22,
  diskBrightness: 5,
  diskRotationSpeed: -8.7,
  turbulenceScale: 1.81,
  turbulenceStretch: 0.75,
  turbulenceSharpness: 7.4,
  turbulenceCycleTime: 5,
  turbulenceLacunarity: 3,
  turbulencePersistence: 0.8,
  diskEdgeSoftnessInner: 0.18,
  diskEdgeSoftnessOuter: 0.5,
  gravitationalLensing: singularityFieldConfig.raymarchLensing,
  dopplerStrength: 1,
  stepSize: 1,
  renderShellRadius: 256,
  raymarchEntryRadius: 52,
  starsEnabled: true,
  starBackgroundColor: "#000000",
  starDensity: 0.1,
  starSize: 1.2,
  starBrightness: 0.1,
  nebulaEnabled: true,
  nebula1Scale: 2,
  nebula1Density: 0.5,
  nebula1Brightness: 0.01,
  nebula1Color: "#071f44",
  nebula2Scale: 5.5,
  nebula2Density: 0.05,
  nebula2Brightness: 0.21,
  nebula2Color: "#010615",
  bloomStrength: 0.68,
  bloomRadius: 0.2,
  bloomThreshold: 0.4,
  connectorWidth: 0.16,
  connectorOpacity: 0.07,
  connectorBrightness: 0.9,
  connectorColor: "#b7c6e8",
};
